import { isEnumValid } from '@philips-emr/tws-utils';

import ComponentType from '../component-type';
import Catalog from '../registry/catalog';
import ComponentInfo, { API, ComponentClass } from '../registry/component-info';
import Constructor from '../util/constructor';
import MetaValidator from '../util/meta-validator';

interface Args {
  name?: string;
  description?: string;
  type: ComponentType;
  api?: API;
}

const validator = MetaValidator.create()
  .str('name')
  .str('description')
  .custom('type', true, (value: any) => isEnumValid(ComponentType, value))
  .custom('api', false, (value: any) => Object.getPrototypeOf(value) !== null)
  .validator();

function AwesomeComponent(definition: ComponentClass | Args, params?: Args): any {
  const validate = MetaValidator.validateDecorator(AwesomeComponent, validator, definition as Constructor, params);

  if (validate) {
    return validate;
  }

  if (!params) throw new Error('[AwesomeComponent]: params not found.');

  const { name, type, api, description } = params;

  const componentName = name || definition.name || '';

  const data = new ComponentInfo(componentName, type, definition as ComponentClass, api, description);

  Catalog.register(componentName, data);

  return definition as any;
}

export default AwesomeComponent;
